import React, { useState } from 'react';
import { useEditor } from '@craftjs/core';
import { Layers } from '@craftjs/layers';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TuneIcon from '@material-ui/icons/Tune';
import LayersIcon from '@material-ui/icons/Layers';

import { Toolbar } from '../../Toolbar';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.craft-layers': {
      '.sc-dTvVRJ, .sc-bRKDuR, .gukymU, .idDWyS, .dbcegl, .jBxXCY': {
        background: `transparent !important`,
        backgroundColor: `transparent !important`,
      },
      'h2': {
        color: `${theme.palette.text.primary} !important`,
      },
      'svg': {
        fill: `${theme.palette.text.secondary} !important`,
      },
      '.inner > div > div:hover': {
        background: `${theme.palette.action.hover} !important`,
      },
    },
  },
  root: {
    width: 300,
    transition: 'margin-right 0.4s cubic-bezier(0.19, 1, 0.22, 1)',
    marginRight: (props) => (props.enabled ? 0 : -300),
    opacity: (props) => (props.enabled ? 1 : 0),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  accordion: {
    backgroundColor: 'inherit',
    color: 'inherit',
    boxShadow: 'none',
  },
  accordionSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: 'inherit',
  },
  accordionDetails: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  layersContent: {
    padding: theme.spacing(1),
    color: '#000',
  },
}));

export const Sidebar = () => {
  const [expanded, setExpanded] = useState(false);
  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));
  const classes = useStyles({ enabled });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box className={classes.root}>
      <Accordion
        square
        className={classes.accordion}
        expanded={expanded === 'customize'}
        onChange={handleChange('customize')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box className={classes.accordionSummary}>
            <TuneIcon fontSize="small" />
            <Typography variant="subtitle2">Ajustes</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Toolbar />
        </AccordionDetails>
      </Accordion>

      <Accordion
        square
        className={classes.accordion}
        expanded={expanded === 'layers'}
        onChange={handleChange('layers')}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box className={classes.accordionSummary}>
            <LayersIcon fontSize="small" />
            <Typography variant="subtitle2">Capas</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <div className={classes.layersContent}>
            <Layers expandRootOnLoad={true} />
          </div>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};